var _rect, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    width: 24,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b22234"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 24,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2.46,
    width: 24,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.92,
    width: 24,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.38,
    width: 24,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9.85,
    width: 24,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12.31,
    width: 24,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.77,
    width: 24,
    height: 1.23
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 8.62,
    fill: "#3c3b6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.b2a4ca401ef98aa2db9a8815298fbfed.svg";
export { ForwardRef as ReactComponent };